export const SPACING_BOTTOM = 64;
export const SPACING_LEFT = 64;
export const SPACING_RIGHT = 12;
export const SPACING_TOP = 12;
